import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t hairline bg-ink-light relative z-10">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <span className="block w-2.5 h-2.5 bg-gold" />
            <span className="font-mono-tech text-sm tracking-[0.3em] text-slate-100">
              NEXUS<span className="text-gold">IPG</span>
            </span>
          </div>
          <p className="font-serif text-2xl md:text-3xl text-slate-200 leading-snug">
            Legacy Applications.<br />Modern Possibilities.
          </p>
          <p className="mt-4 font-mono-tech text-xs tracking-[0.2em] uppercase text-slate-500">
            Evolution, Not Revolution
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="label-mono mb-6">Navigate</p>
          <ul className="space-y-3">
            {[
              ["/", "Home"],
              ["/modernization", "Legacy Application Modernization"],
              ["/servicenow", "ServiceNow Expertise"],
              ["/approach", "Our Approach"],
              ["/about", "About Nexus IPG"],
              ["/contact", "Contact / Assessment"],
            ].map(([to, label]) => (
              <li key={to}>
                <Link
                  to={to}
                  data-testid={`footer-link-${label.toLowerCase().replace(/[\s/]+/g, "-")}`}
                  className="text-base text-slate-300 hover:text-amber-400 transition-colors duration-300"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="label-mono mb-6">Begin</p>
          <p className="text-base text-slate-300 leading-relaxed mb-6">
            A candid assessment of your legacy estate — no predetermined technology
            recommendation, no sales script.
          </p>
          <Link
            to="/contact"
            data-testid="footer-cta-assessment"
            className="inline-flex items-center gap-2 border border-amber-700/50 px-5 py-3 font-mono-tech text-[11px] tracking-[0.22em] uppercase text-amber-400 transition-[background-color,color] duration-300 hover:bg-amber-400 hover:text-ink"
          >
            Request an Assessment
            <ArrowUpRight size={14} />
          </Link>
        </div>
      </div>
      <div className="border-t hairline">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between gap-3">
          <p className="font-mono-tech text-[11px] tracking-wider text-slate-500">
            © {new Date().getFullYear()} Nexus Intelligent Process Group, LLC
          </p>
          <p className="font-mono-tech text-[11px] tracking-wider text-slate-500">
            From COBOL to Claude — and Everything Between
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
